import React, { useEffect, useState } from "react";

import img2014 from "../../../assets/Images/milestone/2014.png";
import img2015 from "../../../assets/Images/milestone/2015.png";
import img2016 from "../../../assets/Images/milestone/2016.png";
import img2017 from "../../../assets/Images/milestone/2017.png";
import img2018 from "../../../assets/Images/milestone/2018.png";
import img2019 from "../../../assets/Images/milestone/2019.png";
import img2020 from "../../../assets/Images/milestone/2020.png";
import img2021 from "../../../assets/Images/milestone/2021.png";
import img2022 from "../../../assets/Images/milestone/2022.png";
import img2023 from "../../../assets/Images/milestone/2023.png";
import img2024 from "../../../assets/Images/milestone/2024.png";
import img2025 from "../../../assets/Images/milestone/2025.png";

import capsuleImg from "../../../assets/Images/milestone/capsule.png";

const timelineData = [
  {
    year: "2014",
    title: "The Birth of Innovation",
    desc: "Beginning a visionary journey in modern nutraceutical manufacturing.",
    image: img2014,
  },
  {
    year: "2015",
    title: "Foundation & Tablet Expansion",
    desc: "Strengthening formulation expertise with advanced tablet solutions.",
    image: img2015,
  },
  {
    year: "2016",
    title: "Initial Manufacturing Phase",
    desc: "Establishing scalable production capabilities for future growth.",
    image: img2016,
  },
  {
    year: "2017",
    title: "Expansion into Tablet Formulation",
    desc: "Enhancing dosage innovation with dedicated tablet manufacturing.",
    image: img2017,
  },
  {
    year: "2018",
    title: "Established of New Entities Nutralike",
    desc: "Expanding the Nutralike ecosystem with new business ventures.",
    image: img2018,
  },
  {
    year: "2019",
    title: "Nutralike’s Landmark Year Growthwise",
    desc: "Achieving significant operational and business growth milestones.",
    image: img2019,
  },
  {
    year: "2020",
    title: "Global Expansion",
    desc: "Taking Nutralike products and partnerships to international markets.",
    image: img2020,
  },
  {
    year: "2021",
    title: "Advanced Production & Customization",
    desc: "Scaling manufacturing with customized, precision-driven nutraceuticals.",
    image: img2021,
  },
  {
    year: "2022",
    title: "New Land Acquisition",
    desc: "Securing space for future infrastructure and manufacturing expansion.",
    image: img2022,
  },
  {
    year: "2023",
    title: "New Facility with Enhanced Capacity",
    desc: "New large-scale facility for efficient production.",
    image: img2023,
  },
  {
    year: "2024",
    title: "Advanced Efficient Production Facility",
    desc: "Integrating smart technologies for precision-driven manufacturing.",
    image: img2024,
  },
  {
    year: "2025",
    title: "Launch of Protein Bars & Cosmetics",
    desc: "Diversifying into innovative wellness and personal care categories.",
    image: img2025,
  },
];

const OurJourney = () => {

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative py-16 sm:py-20 lg:py-28 bg-[#f8faf7] overflow-hidden">

      <style>{`

        .timeline-slider {
          display: flex;
          width: max-content;
          animation: scrollTimeline 65s linear infinite;
          will-change: transform;
        }

        .timeline-slider:hover {
          animation-play-state: paused;
        }

        @keyframes scrollTimeline {
          from {
            transform: translate3d(0,0,0);
          }
          to {
            transform: translate3d(-50%,0,0);
          }
        }

        .glass-card {
          backdrop-filter: blur(14px);
          background: rgba(255,255,255,0.78);
        }

        .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .capsule-float {
          animation: capsuleFloat 4s ease-in-out infinite;
          cursor: default;
          pointer-events: none;
          user-select: none;
        }

        @keyframes capsuleFloat {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
          100% { transform: translateY(0px); }
        }

        .milestone-card {
          animation: cardFloat 5s ease-in-out infinite;
          transition: all .4s ease;
        }

        .milestone-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
        }

        @keyframes cardFloat {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-5px); }
          100% { transform: translateY(0px); }
        }

        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }

        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .dw-fade-up {
          animation: dwFadeUp 1s cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }

        @keyframes dwFadeUp {
          0% {
            opacity: 0;
            transform: translateY(45px);
          }

          100% {
            opacity: 1;
            transform: translateY(0px);
          }
        }

        @media (max-width: 768px) {
          .timeline-slider {
            animation-duration: 45s;
          }
        }

        @media (max-width: 480px) {
          .timeline-slider {
            animation-duration: 38s;
          }
        }

      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* ================= HEADING ================= */}

        <div className="text-center mb-14 sm:mb-16 lg:mb-20">

          <p
            className={`text-[#A4BE2C] tracking-[0.35em] text-[10px] sm:text-xs font-semibold mb-4 sm:mb-5 ${
              isVisible ? "dw-fade-up" : "opacity-0"
            }`}
            style={{ animationDelay: "0ms" }}
          >
            OUR JOURNEY
          </p>

          <h2
            className={`font-serif text-[#355931] text-3xl sm:text-4xl md:text-5xl lg:text-5xl tracking-tight leading-[1.1] ${
              isVisible ? "dw-fade-up" : "opacity-0"
            }`}
            style={{ animationDelay: "120ms" }}
          >
            Building the Future of{" "}

            <span
              className="
                bg-gradient-to-r
                from-[#355931]
                via-[#6D8C2E]
                to-[#A4BE2C]
                bg-clip-text
                text-transparent
              "
            >
              Nutraceutical Innovation
            </span>
          </h2>

          <div
            className={`mx-auto mt-6 m-6 h-[2px] w-24 ${
              isVisible ? 'dw-fade-up' : 'opacity-0'
            }`}
            style={{
              animationDelay: isVisible ? '240ms' : '0ms',
              background:
                'linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)',
            }}
          />


          <p
            className={`max-w-2xl mx-auto text-gray-600 leading-relaxed text-sm sm:text-base px-2 ${
              isVisible ? "dw-fade-up" : "opacity-0"
            }`}
            style={{ animationDelay: "360ms" }}
          >
            A journey driven by innovation, advanced manufacturing,
            global partnerships, and a passion for creating next-generation
            wellness solutions.
          </p>

        </div>

        {/* ================= CAPSULE SECTION ================= */}

        <div className="relative pt-10 sm:pt-14 lg:pt-20 pb-24 sm:pb-28 lg:pb-36 overflow-hidden">

          {/* LEFT SIDE */}
          <div className="hidden xl:flex flex-col gap-4 absolute left-0 top-1/2 -translate-y-1/2 w-[250px]">

            {timelineData.slice(1, 7).map((item, i) => (
              <div
                key={i}
                className="milestone-card bg-white/80 backdrop-blur-xl p-4 rounded-2xl border border-white/50 shadow-md"
              >
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-2.5 h-2.5 rounded-full bg-[#A4BE2C]" />

                  <h4 className="text-[#355931] font-semibold text-sm">
                    {item.year}
                  </h4>
                </div>

                <h5 className="text-sm font-semibold text-[#355931] leading-snug">
                  {item.title}
                </h5>

                <p className="text-xs text-gray-500 mt-1 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            ))}

          </div>

          {/* CENTER CAPSULE */}
          <div className="relative flex flex-col items-center justify-center z-10">

            {/* TOP CARD */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 z-30">

              <div className="milestone-card bg-white/80 backdrop-blur-xl p-4 sm:p-5 rounded-2xl border border-white/50 shadow-md w-[240px] sm:w-[270px]">

                <div className="flex items-center gap-2 mb-1">
                  <span className="w-2.5 h-2.5 rounded-full bg-[#A4BE2C]" />

                  <h4 className="text-[#355931] font-semibold text-sm">
                    2014
                  </h4>
                </div>

                <h5 className="text-sm sm:text-base font-semibold text-[#355931] leading-snug">
                  The Birth of Innovation
                </h5>

                <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                  Beginning a visionary journey in modern nutraceutical manufacturing.
                </p>

              </div>

            </div>

            {/* CAPSULE */}
            <div className="relative flex flex-col items-center justify-center z-10 py-28 sm:py-32">

              <div className="absolute w-[260px] sm:w-[340px] lg:w-[430px] h-[260px] sm:h-[340px] lg:h-[430px] bg-[#A4BE2C]/20 blur-3xl rounded-full" />

              <div className="absolute w-[290px] sm:w-[380px] lg:w-[500px] h-[290px] sm:h-[380px] lg:h-[500px] border border-[#A4BE2C]/20 rounded-full animate-pulse" />

              <img
                src={capsuleImg}
                alt="capsule"
                className="
                  capsule-float
                  relative
                  z-10
                  w-[190px]
                  sm:w-[250px]
                  md:w-[300px]
                  lg:w-[360px]
                  xl:w-[380px]
                  object-contain
                  drop-shadow-[0_20px_50px_rgba(0,0,0,0.18)]
                "
              />

            </div>

            {/* BOTTOM CARD */}
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 z-30">

              <div className="milestone-card bg-white/80 backdrop-blur-xl p-4 sm:p-5 rounded-2xl border border-white/50 shadow-md w-[240px] sm:w-[270px]">

                <div className="flex items-center gap-2 mb-1">
                  <span className="w-2.5 h-2.5 rounded-full bg-[#A4BE2C]" />

                  <h4 className="text-[#355931] font-semibold text-sm">
                    2026
                  </h4>
                </div>

                <h5 className="text-sm sm:text-base font-semibold text-[#355931] leading-snug">
                  Future Innovation Expansion
                </h5>

                <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                  Expanding globally with next-generation wellness and manufacturing solutions.
                </p>

              </div>

            </div>

          </div>

          {/* RIGHT SIDE */}
          <div className="hidden xl:flex flex-col gap-4 absolute right-0 top-1/2 -translate-y-1/2 w-[250px]">

            {timelineData.slice(7, 12).map((item, i) => (
              <div
                key={i}
                className="milestone-card bg-white/80 backdrop-blur-xl p-4 rounded-2xl border border-white/50 shadow-md"
              >
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-2.5 h-2.5 rounded-full bg-[#A4BE2C]" />

                  <h4 className="text-[#355931] font-semibold text-sm">
                    {item.year}
                  </h4>
                </div>

                <h5 className="text-sm font-semibold text-[#355931] leading-snug">
                  {item.title}
                </h5>

                <p className="text-xs text-gray-500 mt-1 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            ))}

          </div>

        </div>

        {/* ================= TIMELINE SLIDER ================= */}

        <div className="h-10 sm:h-14 lg:h-20"></div>

        <div className="relative">

          <div className="hidden md:block absolute top-1/2 left-0 w-full h-[1px] bg-[#A4BE2C]/20 z-0" />

          <div className="overflow-hidden">

            <div className="timeline-slider gap-5 md:gap-8 lg:gap-10 py-5">

              {[...timelineData, ...timelineData].map((item, index) => (

                <div
                  key={index}
                  className={`
                    relative
                    min-w-[280px]
                    sm:min-w-[320px]
                    md:min-w-[380px]
                    lg:min-w-[420px]
                    xl:min-w-[450px]
                    ${
                      index % 2 === 0
                        ? "mt-0"
                        : "mt-10 sm:mt-14 md:mt-20 lg:mt-24"
                    }
                  `}
                >

                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-30 hidden md:flex">
                    <div className="w-4 h-4 lg:w-5 lg:h-5 rounded-full bg-[#A4BE2C] border-[5px] lg:border-[6px] border-white shadow-xl" />
                  </div>

                  <div className="glass-card rounded-[24px] sm:rounded-[28px] lg:rounded-[34px] overflow-hidden border border-white/40 shadow-[0_10px_40px_rgba(0,0,0,0.08)] transition-all duration-700 hover:-translate-y-3 lg:hover:-translate-y-4 hover:shadow-[0_25px_70px_rgba(0,0,0,0.12)]">

                    <div className="overflow-hidden">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="
                          w-full
                          h-[220px]
                          sm:h-[250px]
                          md:h-[280px]
                          lg:h-[300px]
                          object-cover
                          transition-transform
                          duration-700
                          hover:scale-110
                        "
                      />
                    </div>

                    <div className="p-5 sm:p-6 lg:p-8">

                      <span className="text-[#A4BE2C] text-xs sm:text-sm font-semibold tracking-[0.2em] sm:tracking-[0.25em]">
                        {item.year}
                      </span>

                      <h3 className="text-[#355931] text-xl sm:text-2xl md:text-[28px] lg:text-3xl font-serif mt-3 leading-snug">
                        {item.title}
                      </h3>

                      <p className="text-gray-600 leading-relaxed mt-3 text-[13px] sm:text-[14px] lg:text-[15px]">
                        {item.desc}
                      </p>

                    </div>

                  </div>

                </div>

              ))}

            </div>

          </div>

        </div>

        {/* ================= BOTTOM LABEL ================= */}

        <div className="flex items-center justify-center gap-3 sm:gap-4 mt-14 sm:mt-16 lg:mt-20">

          <span className="w-8 sm:w-12 h-[1px] bg-[#A4BE2C]/40" />

          <p className="text-[10px] sm:text-xs tracking-[0.3em] sm:tracking-[0.4em] text-[#355931] font-semibold text-center">
            NUTRALIKE • SINCE 2014
          </p>

          <span className="w-8 sm:w-12 h-[1px] bg-[#A4BE2C]/40" />

        </div>

      </div>
    </section>
  );
};

export default OurJourney;